<ng-container *ngIf="route!=null">
    <div class="block-route-card-info-count"
        matTooltip="{{ 'ROUTECARD.PACKETCOUNT.TOOLTIP' | translate: {value: route.packetCount} }}">
        <div class="route-card-info-count packets">{{ route.packetCount }}</div>
    </div>
    <shared-route-strip-component [route]="route" [isActiveRoutes]="false"></shared-route-strip-component>
</ng-container>